import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { globalModel } from "../global/GlobalModel";

/** 需登录的二级页：未登录时跳转登录并带回跳地址 */
export function useRequireLoginRedirect(): boolean {
  const navigate = useNavigate();
  const location = useLocation();
  const ready = globalModel.initialized;
  const loggedIn = globalModel.isLoggedIn;

  useEffect(() => {
    if (!ready || loggedIn) {
      return;
    }
    const redirect = encodeURIComponent(`${location.pathname}${location.search}`);
    navigate(`/login?redirect=${redirect}`, { replace: true });
  }, [ready, loggedIn, location.pathname, location.search, navigate]);

  return ready && loggedIn;
}
